export const API_ENDPOINTS = {
  FRONTEND: {
    DEV_LOGIN: '/frontend/dev/login',
    SESSION: '/frontend/session',
    SESSION_EXCHANGE: '/frontend/session/exchange',
    SESSION_END: '/frontend/session/end',
    VARIANTS: '/frontend/variants',
    LOBBY_TABLES: '/frontend/lobby/tables',
    LOBBY_BUY_IN: (tableProfileId: number) => `/frontend/lobby/tables/${tableProfileId}/buy-in`,
    LOBBY_CONFIG: '/frontend/lobby/config',
    PRIVATE_ROOMS_CONFIG: '/frontend/private-rooms/config',
    PRIVATE_ROOMS_CREATE: '/frontend/private-rooms',
    PRIVATE_ROOM: (roomCode: string) => `/frontend/private-rooms/${encodeURIComponent(roomCode)}`,
    WALLET_BALANCE: '/frontend/wallet/balance',
    WALLET_TRANSACTIONS: '/frontend/wallet/transactions',
    HAND_HISTORY: '/frontend/history/battles',
    HAND_HISTORY_ACTIONS: (battleId: number) => `/frontend/history/battles/${battleId}/actions`,
  },
} as const;

export const SOCKET_EVENTS = {
  CLIENT: {
    JOIN_TABLE: 'join_table',
    JOIN_PRIVATE_TABLE: 'join_private_table',
    LEAVE_TABLE: 'leave_table',
    PLAYER_ACTION: 'player_action',
    REJOIN_TABLE: 'rejoin_table',
    CHAT_MESSAGE: 'chat_message',
  },
  SERVER: {
    TABLE_STATE: 'table_state',
    CARDS_DEALT: 'cards_dealt',
    ACTION_RESULT: 'action_result',
    TURN_TIMER: 'turn_timer',
    BATTLE_ENDED: 'battle_ended',
    SIDE_SHOW_RESULT: 'side_show_result',
    SESSION_KICKED: 'session_kicked',
    CHAT_MESSAGE: 'chat_message',
    CHAT_HISTORY: 'chat_history',
    ROOM_CLOSED: 'room_closed',
    ERROR: 'error',
  },
} as const;

export const QUICK_CHAT_PHRASES = [
  { id: 'gl', label: 'Good luck!' },
  { id: 'nh', label: 'Nice hand!' },
  { id: 'wp', label: 'Well played' },
  { id: 'gg', label: 'GG' },
  { id: 'hurry', label: 'Please hurry' },
  { id: 'thanks', label: 'Thanks!' },
  { id: 'wow', label: 'Wow!' },
  { id: 'lol', label: 'LOL' },
] as const;

export const CHAT_STICKERS = [
  { id: 'fire', emoji: '🔥', label: 'Fire', animation: 'fire' },
  { id: 'party', emoji: '🎉', label: 'Party', animation: 'party' },
  { id: 'crown', emoji: '👑', label: 'Crown', animation: 'crown' },
  { id: 'cool', emoji: '😎', label: 'Cool', animation: 'cool' },
  { id: 'pray', emoji: '🙏', label: 'Thanks', animation: 'pray' },
  { id: 'money', emoji: '💰', label: 'Money', animation: 'money' },
  { id: 'cards', emoji: '🃏', label: 'Cards', animation: 'cards' },
  { id: 'clap', emoji: '👏', label: 'Clap', animation: 'clap' },
] as const;

export function stickerAnimationClass(stickerId?: string): string {
  if (!stickerId) return '';
  const sticker = CHAT_STICKERS.find((s) => s.id === stickerId);
  if (!sticker?.animation) return 'tp-sticker-animated';
  return `tp-sticker-animated tp-sticker-anim-${sticker.animation}`;
}

export const PLAYER_ACTIONS = [
  'see',
  'blind',
  'chaal',
  'raise',
  'fold',
  'show',
  'side_show',
  'side_show_accept',
  'side_show_reject',
  'shar_accept',
  'shar_decline',
] as const;
export type PlayerAction = (typeof PLAYER_ACTIONS)[number];
